<!--  -->
<template>
  <div class="draught-fan">
    <ioc-table ref="crud" :data="tableData" :option="option" :page="page" @search-change="query" @search-reset="reset"
      @size-change="sizeChange" @current-change="pageChange">
      <template slot="search_time" slot-scope="scope">
        <el-date-picker v-model="scope.row.time" type="datetimerange" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </template>

      <template slot="faultStatus">
        <span class="error-code">故障</span>
      </template>
      <template slot="startTime" slot-scope="scope">
        <span class="startTime-span">{{ scope.row.startTime }}</span>
      </template>
      <template slot="endTime" slot-scope="scope">
        <span class="endTime-span">{{ scope.row.endTime }}</span>
      </template>
      <!-- <template slot="mask" slot-scope="scope">
        <span class="mask-span">{{ scope.row.mask }}</span>
      </template> -->
    </ioc-table>
  </div>
</template>

<script>
import tableOption from "../const/faultConfig";
import utils from "@src/common/utils";
import { api } from "../api/api";
export default {
  data() {
    return {
      page: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      queryForm: {},
      option: tableOption(),
      tableData: [
        {
          status: "1",
          code: "AL20190820",
          startTime: "2023-08-17",
          endTime: "2023-08-17",
          mask: "T<23",
        },
      ],
    };
  },

  components: {},

  computed() { },

  mounted() {
    this.queryList();
  },

  methods: {
    reset() {
      this.queryForm = {};
      this.page.pageNum = 1;
      this.page.pageSize = 10;
      this.queryList();
    },
    query(data) {
      let items = {};
      if (data.time && data.time.length > 0) {
        items.startTime = data.time[0];
        items.endTime = data.time[1];
      }
      // delete data.time;

      this.queryForm = { ...data, ...items };
      this.queryList();
    },
    queryList() {
      let params = {
        ...this.page,
        ...this.queryForm,
      };
      this.$fetch(api.queryFanFaultOperationList, params).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
        }
        this.page.total = res.returnObj.total;
        this.tableData = res.returnObj.list;
      });
    },
    sizeChange(pageSize) {
      this.page.pageNum = 1;
      this.page.pageSize = pageSize;
      this.queryList();
    },
    pageChange(pageNo) {
      this.page.pageNum = pageNo;
      this.queryList();
    },
  },
};
</script>
<style lang='scss' scoped>
.draught-fan {
  margin-left: 0;
  margin-right: 0;
  width: 100%;
  height: 100%;
}
.error-code {
  color: rgb(191, 127, 43);
}

.startTime-span {
  color: rgb(216, 120, 134);
}

.endTime-span {
  color: rgb(147, 240, 5);
}

.mask-span {
  color: rgb(0, 251, 251);
}
</style>